import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'Actions') => ({
	GetActions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActions'
	}),
	CreateRelation: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateRelation'
	}),
	UpdateRelation: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateRelation'
	}),
	DeleteRelation: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteRelation'
	}),
	GetRelations: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetRelations'
	}),
	GetHistories: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetHistories'
	}),
	GetActionItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActionItems'
	}),
	GetActionFormStates: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActionFormStates'
	}),
	GetActionMainItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActionMainItems'
	}),
	UpdateState: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateState'
	}),
	UpdateStateCategory: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateStateCategory'
	})
});

export { getMethods };
